import React from 'react';
import Lottie from 'lottie-react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import notFound from '../assets/Lottie/not-found.json';
import { NotFoundStyles } from './NotFound.styles';

function NotFound() {
  return (
    <>
      <Navbar />
      <NotFoundStyles>

        <Lottie
          animationData={notFound}
          loop
          autoplay
          className="mx-auto lottie-width"
        />
        <h3 className=" text-center ">Oops! Ti Sei Perso!</h3>
        <Link to="/" className="btn  link-color py-2 px-5 mt-3 d-table mx-auto">
          Torna Alla Home
        </Link>

      </NotFoundStyles>
      <Footer />
    </>
  );
}

export default NotFound;
